import toastError from "_hooks/toast";
import { fetchWrapper } from "_helpers";

export const forgotPassword = async (username) => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = baseUrl + `/auth/forgotPassword`;
    const payload = {"username":username}
    let data = await fetchWrapper.post(apiUrl, payload);
    return data;
  } catch (error) {
    console.error("err  ", error);
    toastError("❗ " + error);
    return error;
  }
};

export const resetPassword = async (token,password) => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = baseUrl + `/auth/resetPassword`;
    const payload = {
        "token":token,
        "password":password
    }
    let data = await fetchWrapper.post(apiUrl, payload);
    return data;
  } catch (error) {
    console.error("err  ", error);
    toastError("❗ " + error);
    return error;
  }
};
